import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram, MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";

const COLS = [
  ["Discover", [["/community", "Community"], ["/puja-ideas", "Puja Ideas"], ["/festivals", "Festivals"], ["/content", "Devotional Content"], ["/womens-community", "Women's Community"]]],
  ["Shop & Earn", [["/shop", "Shop"], ["/categories", "Categories"], ["/refer-and-earn", "Refer & Earn"], ["/wallet", "Wallet"], ["/community-chat", "Community Chat"]]],
  ["Company", [["/page/about", "About Us"], ["/page/contact", "Contact"], ["/page/help", "Help Center"]]],
  ["Policies", [["/page/privacy", "Privacy Policy"], ["/page/terms", "Terms"], ["/page/refund", "Refund Policy"], ["/page/shipping", "Shipping Policy"]]],
];

export const SOCIALS = [["youtube", Youtube, "YouTube", "#C4302B"], ["facebook", Facebook, "Facebook", "#1877F2"], ["instagram", Instagram, "Instagram", "#C13584"], ["whatsapp", MessageCircle, "WhatsApp", "#25D366"]];

export default function Footer() {
  const { config } = useApp();
  return (
    <footer className="maroon-pattern mt-16 text-[#FBF7EE]">
      <div className="container-x py-14">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 border-b border-white/10 pb-10 md:flex-row md:items-center">
          <div>
            <p className="eyebrow !text-[#E5C378]">Stay Connected With Us</p>
            <h3 className="font-display mt-2 text-2xl font-bold sm:text-3xl">Join 8,500+ sakhis sharing their devotion</h3>
          </div>
          <div className="flex gap-3">
            {SOCIALS.map(([k, I, l, c]) => (
              <a key={k} href={config?.social?.[k] || "#"} target="_blank" rel="noreferrer" data-testid={`footer-social-${k}`} aria-label={l}
                className="group flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 transition-[transform,background-color] hover:-translate-y-1 hover:bg-white">
                <I className="h-6 w-6 text-white transition-colors group-hover:text-[var(--c)]" style={{ "--c": c }} />
              </a>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2 md:col-span-1">
            <img src="/logo.png" alt="Bhakti Sakhi" className="h-24 w-auto rounded-2xl bg-[#FFFDF7] p-2" />
            <p className="mt-3 text-sm text-white/70">India's devotional community where people discover, share, connect and shop.</p>
          </div>
          {COLS.map(([h, links]) => (
            <div key={h}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#E5C378]">{h}</p>
              <ul className="space-y-2 text-sm text-white/75">
                {links.map(([to, l]) => <li key={to}><Link to={to} className="hover:text-white" data-testid={`footer-link-${to.replace(/\W+/g, "-")}`}>{l}</Link></li>)}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-12 border-t border-white/10 pt-6 text-xs text-white/60">© 2026 Bhakti Sakhi. All Rights Reserved. Referral rewards are subject to eligibility. Terms & Conditions Apply.</p>
      </div>
    </footer>
  );
}
